import {Formik, Form} from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/formikControl/FormikControl'
import toast from 'react-hot-toast'
import {addPIRtoBus, getPIR} from './api'
import {useQuery} from 'react-query'
import {RunnerBall} from '../../../components/FormLoader'
import {handleApiError} from '../../../helpers/errorHandler'
import {Col, Row} from 'react-bootstrap'
import FormResetBtn from '../../../components/FormResetBtn'
import FormSubmitBtn from '../../../components/FormSubmitBtn'

function PIR({initialValues: busDetails, onAfterSubmit}) {
  const {data, isFetching} = useQuery('pir', () => getPIR(busDetails.bus_id), {
    refetchOnWindowFocus: false,
  })

  if (isFetching) {
    return <RunnerBall />
  }

  const device1 = data?.data[0]
  const device2 = data?.data[1]

  const formValues = {
    device_id1: device1?.device_id || '',
    x_pos_max1: device1?.x_pos_max || 0,
    x_neg_max1: device1?.x_neg_max || 0,
    y_max1: device1?.y_max || 0,

    device_id2: device2?.device_id || '',
    x_pos_max2: device2?.x_pos_max || 0,
    x_neg_max2: device2?.x_neg_max || 0,
    y_max2: device2?.y_max || 0,

    bus_name: busDetails.bus_name + ' - ' + busDetails.bus_registration_number,
    bus_id: busDetails.bus_id,
  }

  const submitHandler = (values, {setSubmitting: setLoading}) => {
    setLoading(true)
    const toastId = toast.loading('Submitting')

    addPIRtoBus({
      bus_id: values.bus_id,
      device_id1: values.device_id1,
      x_pos_max1: Number(values.x_pos_max1),
      x_neg_max1: Number(values.x_neg_max1),
      y_max1: Number(values.y_max1),
      device_id2: values.device_id2,
      x_pos_max2: Number(values.x_pos_max2),
      x_neg_max2: Number(values.x_neg_max2),
      y_max2: Number(values.y_max2),
    })
      .then(() => {
        toast.success('Success', {id: toastId})
        onAfterSubmit()
      })
      .catch((err) => {
        handleApiError(err, toastId)
      })
      .then((res) => setLoading(false))
  }

  return (
    <div className="px-5 py-3">
      <Formik
        initialValues={formValues}
        validationSchema={Yup.object().shape({
          device_id1: Yup.string()
            .trim()
            .test('at-least-one', 'At least one device ID is required', function (value) {
              return !!(value?.trim() || this.parent.device_id2?.trim())
            })
            .test('not-equal', 'Device IDs must not be the same', function (value) {
              return !(value?.trim() && value.trim() === this.parent.device_id2?.trim())
            }),
          device_id2: Yup.string()
            .trim()
            .test('not-equal', 'Device IDs must not be the same', function (value) {
              return !(value?.trim() && value.trim() === this.parent.device_id1?.trim())
            }),
          x_pos_max1: Yup.number().typeError('Must be a number'),
          x_neg_max1: Yup.number().typeError('Must be a number'),
          y_max1: Yup.number().typeError('Must be a number'),
          x_pos_max2: Yup.number().typeError('Must be a number'),
          x_neg_max2: Yup.number().typeError('Must be a number'),
          y_max2: Yup.number().typeError('Must be a number'),
        })}
        onSubmit={submitHandler}
      >
        {({isSubmitting, resetForm, dirty, isValid}) => (
          <Form>
            <Row className="">
              <FormikControl
                control="input"
                placeholder="Bus Brand"
                label="Bus"
                name="bus_name"
                disabled
              />
              <Col sm="6">
                <div className="text-center fw-bold mb-2 fs-5">Device 1</div>
                <div className="border border-secondary rounded-4 px-5 pt-3">
                  <FormikControl
                    control="input"
                    size="sm"
                    placeholder="Device Id"
                    label="Device Id"
                    name="device_id1"
                  />
                  <FormikControl
                    control="input"
                    size="sm"
                    placeholder="X pos max"
                    label="X pos max"
                    name="x_pos_max1"
                  />
                  <FormikControl
                    control="input"
                    size="sm"
                    placeholder="X neg max"
                    label="X neg max"
                    name="x_neg_max1"
                  />
                  <FormikControl
                    control="input"
                    size="sm"
                    placeholder="Y max"
                    label="Y max"
                    name="y_max1"
                  />
                </div>
              </Col>
              <Col sm="6">
                <div className="text-center fw-bold mb-2 fs-5">Device 2</div>
                <div className="border border-secondary rounded-4 px-5 pt-3">
                  <FormikControl
                    control="input"
                    size="sm"
                    placeholder="Device Id"
                    label="Device Id"
                    name="device_id2"
                  />
                  <FormikControl
                    control="input"
                    size="sm"
                    placeholder="X pos max"
                    label="X pos max"
                    name="x_pos_max2"
                  />
                  <FormikControl
                    control="input"
                    size="sm"
                    placeholder="X neg max"
                    label="X neg max"
                    name="x_neg_max2"
                  />
                  <FormikControl
                    control="input"
                    size="sm"
                    placeholder="Y max"
                    label="Y max"
                    name="y_max2"
                  />
                </div>
              </Col>
            </Row>
            <div className="text-center pt-10">
              <FormResetBtn onClick={() => resetForm} disabled={isSubmitting} className="me-4" />

              <FormSubmitBtn disabled={!dirty || !isValid || isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default PIR
